
// import React, { useState } from "react";
// import { AppBar, Toolbar, Button, IconButton, Drawer, List, ListItem, ListItemText, Box } from "@mui/material";
// import { Link } from "react-router-dom";
// import MenuIcon from '@mui/icons-material/Menu';

// const SecondNav = () => {
//   const [drawerOpen, setDrawerOpen] = useState(false);

//   const navItems = [
//     { name: "HOME", path: "/" },
//     { name: "ABOUT ARMOUR PRO", path: "/about" },
//     { name: "SERVICES", path: "/services" },
//     { name: "PACKAGES", path: "/packages" },
//     { name: "GALLERY", path: "/gallery" },
//     { name: "FRANCHISE", path: "/franchise" },   // New item
//     { name: "WARRANTY", path: "/warranty" }, 
//     { name: "LOCATIONS", path: "/locations" },
//     { name: "FAQ", path: "/faq" },
//     { name: "CONTACT", path: "/contact" },
//     { name: "BOOKING", path: "/booking" },
//     { name: "SIGN UP", path: "/signup" },
//   ];

//   const toggleDrawer = (open) => (event) => {
//     if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
//       return;
//     }
//     setDrawerOpen(open);
//   };

//   const drawerContent = (
//     <Box
//       sx={{ width: 250, backgroundColor: "#000000", height: "100%", color: "#ffffff" }}
//       role="presentation"
//       onClick={toggleDrawer(false)}
//       onKeyDown={toggleDrawer(false)}
//     >
//       <List>
//         {navItems.map((item) => (
//           <ListItem
//             key={item.name}
//             component={Link}
//             to={item.path}
//             sx={{
//               color: "#ffffff",
//               "&:hover": {
//                 color: "#2E9FFF",
//                 backgroundColor: "transparent",
//               },
//             }}
//           >
//             <ListItemText primary={item.name} />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );

//   return (
//     <>
//       <AppBar
//         position="fixed"
//         sx={{
//           backgroundColor: "#000000",
//           top: "100px",
//           width: "100%",
//           zIndex: 1100,
//         }}
//       >
//         <Toolbar sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
//           {/* Navigation items for larger screens */}
//           <Box
//             sx={{
//               display: { xs: "none", md: "flex" }, // Hide on small screens, show on medium and up
//               justifyContent: "center",
//               flexGrow: 1,
//               gap: "25px",
//             }}
//           >
//             {navItems.map((item) => (
//               <Button
//                 key={item.name}
//                 component={Link}
//                 to={item.path}
//                 sx={{
//                   color: "#FFFFFF",
//                   textTransform: "none",
//                   fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
//                   fontSize: "16px",
//                   padding: "6px 8px",
//                   position: "relative",
//                   "&:hover": {
//                     color: "#2E9FFF",
//                     backgroundColor: "transparent",
//                     "&::after": {
//                       content: '""',
//                       position: "absolute",
//                       bottom: "4px",
//                       left: "0",
//                       width: "100%",
//                       height: "2px",
//                       backgroundColor: "#2E9FFF",
//                       transform: "scaleX(1)",
//                       transition: "transform 0.3s ease",
//                     },
//                   },
//                   "&::after": {
//                     content: '""',
//                     position: "absolute",
//                     bottom: "4px",
//                     left: "0",
//                     width: "100%",
//                     height: "2px",
//                     backgroundColor: "#2E9FFF",
//                     transform: "scaleX(0)",
//                     transformOrigin: "center",
//                     transition: "transform 0.3s ease",
//                   },
//                 }}
//               >
//                 {item.name}
//               </Button>
//             ))}
//           </Box>

//           {/* Hamburger menu for small screens, positioned on the right */}
//           <IconButton
//             color="inherit"
//             edge="end"
//             onClick={toggleDrawer(true)}
//             sx={{
//               display: { xs: "block", md: "none" }, // Show on small screens, hide on medium and up
//               position: "absolute",
//               right: "10px", // Changed from left to right
//             }}
//           >
//             <MenuIcon />
//           </IconButton>
//         </Toolbar>
//       </AppBar>

//       {/* Drawer for small screens */}
//       <Drawer
//         anchor="right" // Changed from left to right to match the toggle button's position
//         open={drawerOpen}
//         onClose={toggleDrawer(false)}
//         sx={{
//           "& .MuiDrawer-paper": {
//             backgroundColor: "#000000",
//           },
//         }}
//       >
//         {drawerContent}
//       </Drawer>
//     </>
//   );
// };

// export default SecondNav;









import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box
} from "@mui/material";
import { Link } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';

const SecondNav = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navItems = [
    { name: "HOME", path: "/" },
    { name: "ABOUT ARMOUR PRO", path: "/about" },
    { name: "SERVICES", path: "/services" },
    { name: "PACKAGES", path: "/packages" },
    { name: "GALLERY", path: "/gallery" },
    { name: "FRANCHISE", path: "/franchise" },
    { name: "WARRANTY", path: "/warranty" },
    { name: "LOCATIONS", path: "/locations" },
    { name: "FAQ", path: "/faq" },
    { name: "CONTACT", path: "/contact" },
    { name: "BOOKING", path: "/booking" },
    { name: "SIGN UP", path: "/signup" },
  ];

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const drawerContent = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#000000",
        height: "100%",
        color: "#ffffff",
        pt: { xs: "120px", md: 0 }, // Add top padding in mobile view so HOME is visible
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {navItems.map((item) => (
          <ListItem
            key={item.name}
            component={Link}
            to={item.path}
            sx={{
              color: "#ffffff",
              "&:hover": {
                color: "#2E9FFF",
                backgroundColor: "transparent",
              },
            }}
          >
            <ListItemText primary={item.name} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#000000",
           top: { xs: "60px", md: "100px" }, // 60px for mobile, 100px for desktop
          width: "100%",
          zIndex: 1100,
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
          {/* Desktop Navigation */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              flexGrow: 1,
              gap: "20px", // slightly reduce spacing
              flexWrap: "wrap",
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.name}
                component={Link}
                to={item.path}
                sx={{
                  color: "#FFFFFF",
                  textTransform: "none",
                  fontFamily: '"BMWTypeNext Pro", Arial, sans-serif',
                  fontSize: "13px", // smaller font size for desktop
                  padding: "5px 8px",
                  position: "relative",
                  "&:hover": {
                    color: "#2E9FFF",
                    backgroundColor: "transparent",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "4px",
                      left: "0",
                      width: "100%",
                      height: "2px",
                      backgroundColor: "#2E9FFF",
                      transform: "scaleX(1)",
                      transition: "transform 0.3s ease",
                    },
                  },
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    bottom: "4px",
                    left: "0",
                    width: "100%",
                    height: "2px",
                    backgroundColor: "#2E9FFF",
                    transform: "scaleX(0)",
                    transformOrigin: "center",
                    transition: "transform 0.3s ease",
                  },
                }}
              >
                {item.name}
              </Button>
            ))}
          </Box>

          {/* Hamburger menu for mobile */}
          <IconButton
            color="inherit"
            edge="end"
            onClick={toggleDrawer(true)}
            sx={{
              display: { xs: "block", md: "none" },
              position: "absolute",
              right: "10px",
            }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        sx={{
          "& .MuiDrawer-paper": {
            backgroundColor: "#000000",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </>
  );
};

export default SecondNav;
